module.exports = __webpack_public_path__ + "img/4.97148be2.jpg";